interface BookmarkIconProps {
  colour?: string;
  size?: "small" | "medium" | "large";
}

export const BookmarkIcon = ({
  colour = "#283472",
  size = "medium",
}: BookmarkIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size === "small" ? 12 : size === "large" ? 20 : 16}
      height={size === "small" ? 12 : size === "large" ? 20 : 16}
      viewBox="5 2 14 19"
    >
      <defs>
        <filter
          id="b"
          width="139.3%"
          height="132.4%"
          x="-19.6%"
          y="-10.3%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation=".75"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0.647058824 0 0 0 0 0.670588235 0 0 0 0 0.780392157 0 0 0 1 0"
          />
        </filter>
        <filter
          id="d"
          width="139.3%"
          height="132.4%"
          x="-19.6%"
          y="-10.3%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation=".75"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0.647058824 0 0 0 0 0.670588235 0 0 0 0 0.780392157 0 0 0 1 0"
          />
        </filter>
        <filter
          id="h"
          width="136.4%"
          height="124.2%"
          x="-18.2%"
          y="-6.1%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation=".5"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0.917647059 0 0 0 0 0.925490196 0 0 0 0 0.964705882 0 0 0 1 0"
          />
        </filter>
        <filter
          id="j"
          width="136.4%"
          height="124.2%"
          x="-18.2%"
          y="-6.1%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation=".5"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0.917647059 0 0 0 0 0.925490196 0 0 0 0 0.964705882 0 0 0 1 0"
          />
        </filter>
        <path
          id="a"
          d="M7.5638852,4 L16.4361148,4 C17.3276335,4 17.6509198,4.09282561 17.9768457,4.2671327 C18.3027716,4.4414398 18.5585602,4.69722837 18.7328673,5.0231543 C18.9071744,5.34908022 19,5.67236646 19,6.5638852 L19,21 L19,21 L12,18 L5,21 L5,6.5638852 C5,5.67236646 5.09282561,5.34908022 5.2671327,5.0231543 C5.4414398,4.69722837 5.69722837,4.4414398 6.0231543,4.2671327 C6.34908022,4.09282561 6.67236646,4 7.5638852,4 Z"
        />
        <path
          id="c"
          d="M7.5638852,4 L16.4361148,4 C17.3276335,4 17.6509198,4.09282561 17.9768457,4.2671327 C18.3027716,4.4414398 18.5585602,4.69722837 18.7328673,5.0231543 C18.9071744,5.34908022 19,5.67236646 19,6.5638852 L19,21 L19,21 L12,18 L5,21 L5,6.5638852 C5,5.67236646 5.09282561,5.34908022 5.2671327,5.0231543 C5.4414398,4.69722837 5.69722837,4.4414398 6.0231543,4.2671327 C6.34908022,4.09282561 6.67236646,4 7.5638852,4 Z"
        />
        <path
          id="g"
          d="M7.7819426,2 L16.2180574,2 C16.6638168,2 16.8254599,2.04641281 16.9884229,2.13356635 C17.1513858,2.2207199 17.2792801,2.34861419 17.3664336,2.51157715 C17.4535872,2.67454011 17.5,2.83618323 17.5,3.2819426 L17.5,18.5 L17.5,18.5 L12,16.25 L6.5,18.5 L6.5,3.2819426 C6.5,2.83618323 6.54641281,2.67454011 6.63356635,2.51157715 C6.7207199,2.34861419 6.84861419,2.2207199 7.01157715,2.13356635 C7.17454011,2.04641281 7.33618323,2 7.7819426,2 Z"
        />
        <path
          id="i"
          d="M7.7819426,2 L16.2180574,2 C16.6638168,2 16.8254599,2.04641281 16.9884229,2.13356635 C17.1513858,2.2207199 17.2792801,2.34861419 17.3664336,2.51157715 C17.4535872,2.67454011 17.5,2.83618323 17.5,3.2819426 L17.5,18.5 L17.5,18.5 L12,16.25 L6.5,18.5 L6.5,3.2819426 C6.5,2.83618323 6.54641281,2.67454011 6.63356635,2.51157715 C6.7207199,2.34861419 6.84861419,2.2207199 7.01157715,2.13356635 C7.17454011,2.04641281 7.33618323,2 7.7819426,2 Z"
        />
        <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#FAFAFB" />
          <stop offset="13.137%" stopColor="#F4F4F6" />
          <stop offset="35.472%" stopColor="#9396A9" />
          <stop offset="68.308%" stopColor="#F4F4F6" />
          <stop offset="100%" stopColor="#EAEAEE" />
        </linearGradient>
        <linearGradient id="f" x1="50%" x2="50%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#FAFAFB" />
          <stop offset="3.907%" stopColor="#C6C8D2" />
          <stop offset="8.632%" stopColor="#E0E0E6" />
          <stop offset="13.894%" stopColor="#C6C8D2" />
          <stop offset="24.294%" stopColor="#83869B" />
          <stop offset="33.268%" stopColor="#494C5C" />
          <stop offset="46.187%" stopColor="#1D1E24" />
          <stop offset="55.388%" stopColor="#202128" />
          <stop offset="69.52%" stopColor="#3B3E4B" />
          <stop offset="83.453%" stopColor="#73778D" />
          <stop offset="100%" stopColor="#9396A9" />
        </linearGradient>
        <linearGradient id="k" x1="50%" x2="50%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#FAFAFB" />
          <stop offset="3.907%" stopColor="#C6C8D2" />
          <stop offset="8.632%" stopColor="#E0E0E6" />
          <stop offset="13.894%" stopColor="#C6C8D2" />
          <stop offset="24.294%" stopColor="#83869B" />
          <stop offset="33.268%" stopColor="#494C5C" />
          <stop offset="46.187%" stopColor="#1D1E24" />
          <stop offset="55.388%" stopColor="#202128" />
          <stop offset="69.52%" stopColor="#3B3E4B" />
          <stop offset="83.453%" stopColor="#73778D" />
          <stop offset="100%" stopColor="#9396A9" />
        </linearGradient>
      </defs>
      <g fill="none">
        <use xlinkHref="#a" fill="#000" filter="url(#b)" />
        <use xlinkHref="#a" fill={colour} fillRule="evenodd" />
        <use xlinkHref="#c" fill="#000" filter="url(#d)" />
        <use
          xlinkHref="#c"
          fill="url(#e)"
          fillRule="evenodd"
          style={{ mixBlendMode: "luminosity" }}
        />
        <use
          xlinkHref="#c"
          fill="url(#f)"
          fillOpacity=".2"
          fillRule="evenodd"
          style={{ mixBlendMode: "saturation" }}
        />
        <use xlinkHref="#g" fill="#000" filter="url(#h)" />
        <use xlinkHref="#g" fill={colour} fillRule="evenodd" />
        <use
          xlinkHref="#i"
          fill="url(#k)"
          fillRule="evenodd"
          style={{ mixBlendMode: "luminosity" }}
        />
        <use
          xlinkHref="#i"
          fill="url(#k)"
          fillOpacity=".2"
          fillRule="evenodd"
          style={{ mixBlendMode: "saturation" }}
        />
      </g>
    </svg>
  );
};
